
import { Component, Vue } from "vue-property-decorator"

import api from "@/services/api"
import setBrandingLink from "@/scripts/brandingLink"
import HelpIcon from "@/components/New/Page/PageComponents/HelpIcon.vue"

@Component({
	components: {
		"help-icon": HelpIcon
	}
})
export default class CssSetup extends Vue {
	css: string = ""
	revertCss: string = "";

	get cssChanged (): boolean {
		return this.css !== this.revertCss
	}

	async mounted () {
		this.revertCss = this.css = await api.tenantBrandingGet()
	}

	revert () {
		this.css = this.revertCss
	}

	async save () {
		await api.tenantBrandingPost(this.css)
		this.revertCss = this.css

		setBrandingLink(null)
		await this.$nextTick()
		setBrandingLink("updated")
	}
}

